/* TODO: Refactor this file to generate dates by traversing filtered design object.keys
 * (eg. don't generate completedByUserUuid & status).
 * We can probably leverage C:\Users\jwcom\Desktop\Kana\web\src\route\shared\projects\project\overview\components\StandardSpecificSection\components\RenderComponent.tsx
 * to do this, we will need to remove the expression interpreter / schema related bits from it
 * Will create a shared compenent for all dates sections for this
 */
import { ProjectDatesConstants } from "../../../../constants";
import { ProjectPhaseStatus } from "../../../../models";
import { Column, DatePicker, KanaTooltip, Row } from "../../../../widget";
import { EditDatesPanelBanner } from "../EditDatesPanelBanner";
import { DateSectionProps } from "../models";

const START_LABEL = "Phase start date";
const END_LABEL = "Phase end date";
export const DesignSection = ({
  dates,
  handleUpdateProjectDates,
  hasDateError,
  schema,
}: DateSectionProps): JSX.Element => {
  return (
    <>
      <Row spacingV="m">
        <Column span={12}>
          <p className="body01">Design</p>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <p className="body1">
            Enter key dates to help structure your workflow and align with your broader roadmap. These can be either
            confirmed or estimated, and can be updated as the project develops.
          </p>
        </Column>
      </Row>
      <Row spacingV={schema?.design.properties.registrationDate !== undefined ? "l" : "xl"}>
        <Column span="4_half">
          <DatePicker
            label={START_LABEL}
            value={dates.design?.start}
            onChange={(date) => handleUpdateProjectDates(date, "design.start")}
            hasError={hasDateError("design.start")}
            tooltip={
              <KanaTooltip
                tooltipHeader=""
                tooltipText={ProjectDatesConstants.DESIGN_START_TOOLTIP_TEXT}
                hasError={hasDateError("design.start")}
              />
            }
          />
        </Column>
        <Column offset="1_half" span="4_half">
          <DatePicker
            label={END_LABEL}
            value={dates.design?.end}
            onChange={(date) => {
              handleUpdateProjectDates(date, "design.end");
              handleUpdateProjectDates(
                date !== undefined ? new Date(new Date(date).setDate(date.getDate() + 1)) : undefined,
                "implementation.start"
              );
            }}
            hasError={hasDateError("design.end")}
            tooltip={
              <KanaTooltip
                tooltipHeader=""
                tooltipText={ProjectDatesConstants.DESIGN_END_TOOLTIP_TEXT}
                hasError={hasDateError("design.end")}
              />
            }
          />
        </Column>
      </Row>
      {schema?.design.properties.registrationDate !== undefined && (
        <Row spacingV="xl">
          <Column span="4_half">
            <DatePicker
              label="Registration date"
              value={dates.design?.registrationDate}
              onChange={(date) => handleUpdateProjectDates(date, "design.registrationDate")}
              hasError={hasDateError("design.registrationDate")}
              tooltip={
                <KanaTooltip
                  tooltipHeader=""
                  tooltipText={ProjectDatesConstants.DESIGN_REGISTRATION_DATE_TOOLTIP_TEXT}
                  hasError={hasDateError("design.registrationDate")}
                />
              }
            />
          </Column>
        </Row>
      )}
      <EditDatesPanelBanner phaseStatus={dates.design.status as ProjectPhaseStatus} phaseEndDate={dates.design.end} />
    </>
  );
};
